export default "__VITE_ASSET__Brt4ts8f__"